import {
  Instance_default
} from "./chunk-6SWJHUPL.js";
import {
  BaseRoute_default
} from "./chunk-QJTNIX2I.js";

// src/Bi/BiRoute.ts
var version = "/v1/";
var BiRoute = class extends BaseRoute_default {
  constructor() {
    super(...arguments);
    this.getAttribute = (dataFilter, dateFilter) => {
      return Instance_default.get(
        this.createRequestURL(
          {
            url: "attribute" + version,
            date: dateFilter,
            filter: dataFilter
          },
          false,
          process.env.REACT_APP_BI_ENDPOINT_URL,
          true
        )
      );
    };
    this.getAttributeDate = (dataFilter, dateFilter) => {
      return Instance_default.get(
        this.createRequestURL(
          {
            url: "attribute_date" + version,
            date: dateFilter,
            filter: dataFilter
          },
          false,
          process.env.REACT_APP_BI_ENDPOINT_URL,
          true
        )
      );
    };
    this.getFlowDetail = (flowId, dataFilter) => {
      return Instance_default.get(
        this.createRequestURL(
          {
            url: "flow" + version + flowId,
            filter: dataFilter
          },
          false,
          process.env.REACT_APP_BI_ENDPOINT_URL,
          true
        )
      );
    };
    this.getVisitor = (dataFilter, dateFilter) => {
      return Instance_default.get(
        this.createRequestURL(
          {
            url: "visitor" + version,
            date: dateFilter,
            filter: dataFilter
          },
          false,
          process.env.REACT_APP_BI_ENDPOINT_URL,
          true
        )
      );
    };
    this.getVisitors = (dataFilter, dateFilter) => {
      return Instance_default.get(
        this.createRequestURL(
          {
            url: "visitors" + version,
            date: dateFilter,
            filter: dataFilter
          },
          false,
          process.env.REACT_APP_BI_ENDPOINT_URL,
          true
        )
      );
    };
    this.getVisits = (dataFilter, dateFilter) => {
      return Instance_default.get(
        this.createRequestURL(
          {
            url: "visits" + version,
            filter: dataFilter,
            date: dateFilter
          },
          false,
          process.env.REACT_APP_BI_ENDPOINT_URL,
          true
        )
      );
    };
    this.getMetrics = (dataFilter, dateFilter) => {
      return Instance_default.get(
        this.createRequestURL(
          {
            url: "metrics" + version,
            filter: dataFilter,
            date: dateFilter
          },
          false,
          process.env.REACT_APP_BI_ENDPOINT_URL,
          true
        )
      );
    };
    this.getSummary = (dataFilter, dateFilter) => {
      return Instance_default.get(
        this.createRequestURL(
          {
            url: "domains" + version,
            filter: dataFilter,
            date: dateFilter
          },
          false,
          process.env.REACT_APP_BI_ENDPOINT_URL,
          true
        )
      );
    };
    this.getDevices = (dataFilter, dateFilter) => {
      return Instance_default.get(
        this.createRequestURL(
          {
            url: "devices" + version,
            filter: dataFilter,
            date: dateFilter
          },
          false,
          process.env.REACT_APP_BI_ENDPOINT_URL,
          true
        )
      );
    };
    this.getCountries = (dataFilter, dateFilter) => {
      return Instance_default.get(
        this.createRequestURL(
          {
            url: "countries" + version,
            filter: dataFilter,
            date: dateFilter
          },
          false,
          process.env.REACT_APP_BI_ENDPOINT_URL,
          true
        )
      );
    };
    this.getCities = (dataFilter, dateFilter) => {
      return Instance_default.get(
        this.createRequestURL(
          {
            url: "cities" + version,
            filter: dataFilter,
            date: dateFilter
          },
          false,
          process.env.REACT_APP_BI_ENDPOINT_URL,
          true
        )
      );
    };
    this.getBrowsers = (dataFilter, dateFilter) => {
      return Instance_default.get(
        this.createRequestURL(
          {
            url: "browsers" + version,
            filter: dataFilter,
            date: dateFilter
          },
          false,
          process.env.REACT_APP_BI_ENDPOINT_URL,
          true
        )
      );
    };
    this.getLanguages = (dataFilter, dateFilter) => {
      return Instance_default.get(
        this.createRequestURL(
          {
            url: "languages" + version,
            filter: dataFilter,
            date: dateFilter
          },
          false,
          process.env.REACT_APP_BI_ENDPOINT_URL,
          true
        )
      );
    };
    this.getPages = (dataFilter, dateFilter) => {
      return Instance_default.get(
        this.createRequestURL(
          {
            url: "pages" + version,
            filter: dataFilter,
            date: dateFilter
          },
          false,
          process.env.REACT_APP_BI_ENDPOINT_URL,
          true
        )
      );
    };
    this.getEvents = (dataFilter, dateFilter) => {
      return Instance_default.get(
        this.createRequestURL(
          {
            url: "events" + version,
            filter: dataFilter,
            date: dateFilter
          },
          false,
          process.env.REACT_APP_BI_ENDPOINT_URL,
          true
        )
      );
    };
    this.init = () => {
      return Instance_default.post(
        this.createRequestURL(
          {
            url: "visitor" + version + "init"
          },
          false,
          process.env.REACT_APP_BI_ENDPOINT_URL,
          true
        ),
        {
          ...{
            ip: "1.1.1.1",
            user_agent: "Mozilla/5.0",
            device: "iPhone 13",
            browser_name: "Firefox",
            browser_version: "75",
            domain: "aesirx.io",
            lang: "en-GB",
            url: "https://aesirx.io",
            referer: "https://r-digital.tech",
            event_name: "visit",
            event_type: "action",
            attributes: [
              {
                name: "form_id",
                value: "xxx"
              }
            ]
          }
        }
      );
    };
  }
};
var BiRoute_default = BiRoute;

export {
  BiRoute_default
};
/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
